import type { SavedViewSummary } from '@repo/schema/table-configuration'

/** Default is named for its table. */
export const defaultViewName = ({ label }: { label: string }) => `Default ${label}`

export const ownerLabel = ({ owner }: SavedViewSummary) =>
  `${owner.name} ${owner.last_name ?? ''}`.trim()

export const organisationLabel = ({
  organisation_applicability: applicability,
}: SavedViewSummary) =>
  applicability.type === 'all'
    ? 'All Organisations'
    : applicability.organisations.map(organisation => organisation.name).join(', ')

const counted = (count: number, one: string, many: string) => {
  if (!count) return null
  return `${count} ${count === 1 ? one : many}`
}

export const sharingLabel = ({ audience_summary: audience }: SavedViewSummary) => {
  if (audience.mode === 'owner') return 'Only owner'
  if (audience.mode === 'all') return 'Everyone'
  return [
    counted(audience.user_count, 'user', 'users'),
    counted(audience.role_count, 'role', 'roles'),
  ]
    .filter(Boolean)
    .join(', ')
}

const SHARED_VIA = {
  all: 'Shared with everyone',
  role: 'Through your Role',
  user: 'Shared with you directly',
}

/** How a non-owner reaches the view; owners never see audience identities beyond counts. */
export const sharedViaLabel = ({ shared_via: sharedVia }: SavedViewSummary) =>
  sharedVia.map(path => SHARED_VIA[path]).join(' · ')
